var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricingtable_leftarea"},[_c('ul',_vm._l((_vm.commercialsList),function(item,inx){return _c('li',{key:inx},[_c('span',[_c('img',{attrs:{"src":_vm.iconList[item.serviceGroup],"alt":item.commercialName}})]),_vm._v(" "+_vm._s(item.commercialName)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }